import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { LOCALSTORAGE_PROPERTIES } from "../../../constant/localstorageProperties"

export type TKadoTyoseiState = { 社員ID: number; 稼働調整?: number | null }
const zyomuinKadoTyosei = localStorage.getItem(
  LOCALSTORAGE_PROPERTIES.ZYOMUINKADOTYOSEI
)
const initialState: TKadoTyoseiState[] = zyomuinKadoTyosei
  ? JSON.parse(zyomuinKadoTyosei)
  : {
      社員ID: null,
      稼働調整: null,
    }

export const zyomuinKadoTyoseiSlice = createSlice({
  name: "zyomuinKyuyo",
  initialState,
  reducers: {
    init: (state) => {
      return { ...state, ...initialState }
    },
    add稼働調整: (state, action: PayloadAction<TKadoTyoseiState>) => {
      localStorage.setItem(
        LOCALSTORAGE_PROPERTIES.ZYOMUINKADOTYOSEI,
        JSON.stringify(action.payload)
      )
      return [...state, action.payload]
    },
  },
})

export const zyomuinKyuyoActions = zyomuinKadoTyoseiSlice.actions
